

// Things that this app can do!

export const VOLUME_INCREASE = 'volumeIncrease'
export const VOLUME_DECREASE = 'volumeDecrease'
export const VOLUME_MUTE = 'volumeMute'
export const TEMPO_INCREASE = 'tempoIncrease'
export const TEMPO_DECREASE = 'tempoDecrease'
export const TEMPO_RESET = 'tempoReset'
export const TEMPO_TAP = 'tempoTap'
export const PLAYBACK_TOGGLE = 'playbackToggle'
export const PLAYBACK_START = 'playbackStart'
export const PLAYBACK_STOP = 'playbackStop'
export const NOTE_ON = 'noteOn'
export const NOTE_OFF = 'noteOff'
export const PITCH_BEND = 'pitchBend'

